import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-console-search',
  templateUrl: './console-search.component.html',
  styleUrls: ['./console-search.component.scss'],
})
export class ConsoleSearchComponent implements OnInit {
  constructor(@Inject(APP_BASE_HREF) public baseHref: string) {}
  @Input()
  findOptions;
  @Input()
  showDate;
  @Input()
  showDateRange;
  @Input()
  headercount;
  @Input()
  showHideHeaderColumnCount;

  @Output()
  clearSearchBoxEvent: any = new EventEmitter<any>();
  @Output()
  clearFilterEvent: any = new EventEmitter<any>();
  @Output()
  applyFilterByFieldEvent: any = new EventEmitter<any>();
  @Output()
  showHideColumnsEvent: any = new EventEmitter<any>();
  @Output()
  applySelectedDateRangeEvent: any = new EventEmitter<any>();
  @Output()
  resetDateRangeEvent: any = new EventEmitter<any>();

  public event: EventEmitter<any> = new EventEmitter();
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  fromDate: Date = new Date();
  toDate: Date = new Date();
 
  @Input() initialFromDate: Date;
  @Input() initialToDate: Date;

  @Input() isAIInteractions: boolean = false;
  ngOnInit() 
  {

    if (this.initialFromDate) {
      this.fromDate = new Date(this.initialFromDate);
    } else {
      this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    }
  
    if (this.initialToDate) {
      this.toDate = new Date(this.initialToDate);
    }
  
    this.searchField = this.findOptions[0];
  }


  // ngOnInit() {
  //   this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
  //   this.searchField = this.findOptions[0];
  // }

  clearSearchBox() {
    this.searchValue = '';
    this.clearSearchBoxEvent.emit();
  }
  applyFilterByField() {
    this.applyFilterByFieldEvent.emit({
      searchField: this.searchField,
      searchValue: this.searchValue,
    });
  }
  showHideColumns() {
    this.showHideColumnsEvent.emit();
  }
  applySelectedDateRange() {
    this.applySelectedDateRangeEvent.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
    });
  }
  // resetDateRange() {
  //   this.fromDate = new Date();
  //   this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
  //   this.toDate = new Date();
  //   this.resetDateRangeEvent.emit({
  //     fromDate: this.fromDate,
  //     toDate: this.toDate,
  //   });
    // this.applySelectedDateRangeEvent.emit({
    //   fromDate: this.fromDate,
    //   toDate: this.toDate,
    // });
  //}
  resetDateRange() {
    this.toDate = new Date();
    this.fromDate = new Date();
  
    if (this.isAIInteractions) {
      this.fromDate.setMonth(this.fromDate.getMonth() - 6);
    } else {
      this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    }
  
    this.resetDateRangeEvent.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
    });
  
    this.applySelectedDateRangeEvent.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
    });
  }
  clearFilter() {
    this.clearFilterEvent.emit();
  }
}
